import * as PIXI from 'pixi.js';
import Point = PIXI.Point;

export function clamp(value: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, value));
}

export function distance(a: Point, b: Point): number {
    return Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);
}

export function lerp(a: Point, b: Point, t: number): Point {
    return new Point(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
}



// WEBPACK FOOTER //
// ./src/utils.ts